export default "data:image/gif;base64,R0lGODlhCAAIAJECAFRqO7/Htf///wAAACH5BAEAAAIALAAAAAAIAAgAAAIOlB9wlrH9gEMyTlZXXgUAOw=="